/****************************************************************
 **  Utility to determine serving webp files
 ****************************************************************/
export const isWebPSupported = (): boolean => {
  const elem = document.createElement('canvas');

  if (!!(elem.getContext && elem.getContext('2d'))) {
    // was able or not to get WebP representation
    const supported = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    return supported;
  } else {
    return false;
  }
};
